import type React from "react";
import { useEffect } from "react";
import "./BuildSurvey.css";
import { XIcon } from "lucide-react";

interface DreamerSurveyProps {
  onClose: () => void;
}

const DreamerSurvey: React.FC<DreamerSurveyProps> = ({ onClose }) => {
  const handleGetStarted = () => {
    window.location.href = "https://dreamer.com";
  };

  // Prevent keyboard events from reaching terminal when form is active
  // Also prevent background scrolling
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      e.stopPropagation();
    };

    const handleKeyUp = (e: KeyboardEvent) => {
      e.stopPropagation();
    };

    const handleKeyPress = (e: KeyboardEvent) => {
      e.stopPropagation();
    };

    // Prevent background scroll
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";

    // Prevent touch scrolling on mobile and wheel scrolling
    const handleTouchMove = (e: TouchEvent) => {
      const target = e.target as Element;
      const surveyContent = document.querySelector(".survey-content");

      // Allow scrolling within survey content, prevent elsewhere
      if (surveyContent && !surveyContent.contains(target)) {
        e.preventDefault();
      }
    };

    const handleWheel = (e: WheelEvent) => {
      const target = e.target as Element;
      const surveyContent = document.querySelector(".survey-content");

      // Allow scrolling within survey content, prevent elsewhere
      if (surveyContent && !surveyContent.contains(target)) {
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", handleKeyDown, true);
    document.addEventListener("keyup", handleKeyUp, true);
    document.addEventListener("keypress", handleKeyPress, true);
    document.addEventListener("touchmove", handleTouchMove, { passive: false });
    document.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
      document.removeEventListener("keyup", handleKeyUp, true);
      document.removeEventListener("keypress", handleKeyPress, true);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("wheel", handleWheel);
      document.body.style.overflow = originalStyle;
    };
  }, []);

  return (
    <div
      className="survey-overlay"
      onClick={(e) => e.stopPropagation()}
      onWheel={(e) => e.stopPropagation()}
      onTouchMove={(e) => e.stopPropagation()}
    >
      <button onClick={onClose} className="survey-close">
        <XIcon />
      </button>
      <div className="survey-container">
        <div className="survey-content">
          <div className="survey-step intro-step">
            <h1>Early access to shape something new</h1>
            <p className="overview-text">
              We're bringing together a small community of builders to explore a new medium in our beta.
            </p>
            <button
              onClick={handleGetStarted}
              className="survey-btn primary radiant intro-button"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DreamerSurvey;
